// Bootstrap wants jQuery global
window.jQuery = $ = require('jquery');

// Bootstrap wants Tether global
window.Tether = require('../../node_modules/tether/dist/js/tether.js');

// Load libraries
// Bootstrap;
var bootstrap = require('../../node_modules/bootstrap/dist/js/bootstrap.js');

// Polyfill for img cover on IE.
var aos = require('aos');

// Polyfill for img cover on IE.
var objectFitImages = require('object-fit-images');


// TODO: add files that is concat'ed in the theme here.
// TODO: replace with the drupal ready thing.
/**
// js polyfill
js/flexibility.js: {}

// just the feature checker
 js/modernizr.js: {}

// iscroll - a scroller lib, used for scrolling down. Probably better than jquery?
'https://cdnjs.cloudflare.com/ajax/libs/iScroll/5.1.3/iscroll.min.js': { type: external, minified: true }

 // drawer - used for side menu. - we might use botstrap default instead, or lowend solution from la.
 'https://cdnjs.cloudflare.com/ajax/libs/drawer/3.2.0/js/drawer.min.js': { type: external, minified: true }
*/


(function (Drupal, $, window) {

    // To understand behaviors, see https://www.drupal.org/node/2269515
    Drupal.behaviors.dbxflex = {
        attach: function (context, settings) {

            // Set browser user agent in html to provide styling for IE10 - https://css-tricks.com/ie-10-specific-styles/
            var doc = document.documentElement;
            doc.setAttribute('data-useragent', navigator.userAgent);

            // Polyfill for object-fit.
            objectFitImages();

            if($('body').hasClass('path-frontpage')) {
                var eventsFired = localStorage.getItem('firedstart');
                if (eventsFired != '1'){
                    localStorage.setItem('firedstart', '1');
                    $('body').addClass('doneloading');
                } else {
                    $('body').addClass('doneloading');
                    $('body').addClass('doneloadingfast');
                }
            } else {
                var eventsFired = localStorage.getItem('fired');
                if (eventsFired != '1'){
                    localStorage.setItem('fired', '1');
                    $('body').addClass('doneloading');
                } else {
                    $('body').addClass('doneloading');
                    $('body').addClass('doneloadingfast');
                }
            }



            aos.init({
                offset: 50,
                delay: 0,
                duration: 850
            });

            // Only AOS on startpage
//            if($('body').hasClass('path-frontpage')){
                // Init aos. (Animate on scroll)

  //          }


// Admin fix
//$( "a[href^='/node/4/edit']" ).html( "news here!" );
//$('a[href*="/node/4/edit"]').attr("href","/admin/content?title=&type=coworkers&status=All&langcode=All");
//$("a[href~='/node/4/edit']").css('border','2px solid red');
$('a[href="/node/4/edit"]').remove();

//$('img').remove();


// PDF Move
var pdfmove = $('.documents-slide').html();


//console.log('ping');
//console.log(pdfmove);
if ($('.documents-list').length){


 //   console.log($('#header').innerWidth());

    if ($('#header').innerWidth() >= 768){


        // Remove document slider form the body.
        $('.documents-slide').hide();

        // Add document slider to the header.
        $('#main').append('<div class="documents-slide">' + pdfmove + '</div>');
        $('#main').find('.documents-slide').addClass('docslideheader');

    }





}


    // PDF fix
    $('.documents-list').find('a').attr('target','_blank');
    $('.views-field-field-dokument-pdf').find('a').attr('target','_blank');

    // Citat copy to block for desktop
	if($('#block-dbxflex-content--2').find('span.citat').length){
 $('#block-citat2--2').html('<span class="citat">' + $('#block-dbxflex-content--2').find('span.citat').text() + '</span>');

	}
	/**
            // Kontakt buttons - on page click
            $('#block-javisoker--2, .round-container').find('a.btn-orange').click(function(e){
                e.preventDefault();
                   $(this).addClass('clicked');
                   $(this).html('<span>Ring oss!<br><strong>08-648 10 00</strong></span>');
            });
	*/
	    
            $('#block-javisoker--2').find('a.btn-red').click(function(e){
                e.preventDefault();
                $('#block-jagarintresserad--2').css('display', 'block');
//                $('#block-entityform--2').css('display', 'block');
                $('#block-jagarintresserad--2').css('opacity', '1');
                $('#block-entityform--2').css('opacity', '1');
                $('#block-entityform--2').addClass('expandform');
                $('#block-javisoker--2').css('display','none');
            });
	    

            // Kontakt buttons - hash logic.
            if($('body').hasClass('section-kontakt')){
                if (location.href.indexOf("#") != -1) {
                    var hash = location.href.split('#')[1];
                    //var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
                    if(hash == 'openform'){
                        $('#block-jagarintresserad--2').css('display', 'block');
                 //       $('#block-entityform--2').css('display', 'block');
                        $('#block-jagarintresserad--2').css('opacity', '1');
                        $('#block-entityform--2').css('opacity', '1');
                        $('#block-entityform--2').addClass('expandform');
                        $('#block-javisoker--2').css('display','none');
                    }
                    if(hash == 'tack'){
                        $('#block-javisoker--2').css('display','none');
                        $('#block-tack--2').css('display','block');
                        $('#block-entityform--2').css('display', 'none');
                    }
                } else {
                    // If not, show form buttons.
                    $('#block-javisoker--2').css('display','block');
//		    $('#block-javisoker--2').css('opacity','1');
                    $('#block-jagarintresserad--2').css('display', 'none');
//                    $('#block-entityform--2').css('display', 'none');
                }
            }


            // Kontakt submit
            if($('.contact-message-form').length){
                var custAction = $('.contact-message-form').find('form').attr('action');
                console.log(custAction);
                $('.contact-message-form').find('form').attr('action',custAction + '#openform');
            }

            $('input.error').parent().find('label').addClass('error');


            /**
             * Mobile menu
             */
            $('.fold-btn').bind( "touchstart click", function(e) {
                e.preventDefault();
                if( $('#navigation').hasClass('fold-open') ){
                    $('#navigation').removeClass('fold-open');
                } else {
                    $('#navigation').addClass('fold-open');
                }
            });

            $('#navigation > div > div > nav > ul > li.menu-item--expanded > a').bind( "touchstart click", function(e) {
                e.preventDefault();

                $('.active-fold').removeClass('active-fold');

                $(this).parent().addClass('active-fold');

                /**
                if( $('#navigation').hasClass('fold-open') ){
                    $('#navigation').removeClass('fold-open');
                } else {
                    $('#navigation').addClass('fold-open');
                }
                 */

            });


        }
    };

} (Drupal, jQuery, this));
